import { colors } from "../theme/variables";

export default {
  tabHeader: {
    minHeight: "38px !important",
  },
  wrapper: {
    overflowY: "scroll",
    overflowX: "hidden",
    height: "100%",
  },
  padded: {
    // padding: 30,
  },
  header: {
    backgroundColor: colors.gray14,
    // padding: "20px 30px 0 30px",
    zIndex: 1,
    padding: 5,
  },
  paddingBottom: {
    paddingBottom: 25,
  },
  tabContent: {
    padding: "8px 0",
  },
  buttonRow: {
    marginBottom: 15,
    display: "flex",
    // justifyContent: "flex-end",
    justifyContent: "flex-start",
  },
  buttonRowWorkFlow: {
    paddingLeft: "5px",
    paddingTop: "5px",
    paddingBottom: "3px",
    display: "flex",
    // justifyContent: "flex-end",
    justifyContent: "flex-start",
  },
  field: {
    marginBottom: 15,
  },
  filterBtn: {
    backgroundColor: "transparent",
    padding: "0 16px",
    marginTop: "4px",

    "&:hover": {
      backgroundColor: "#E0F4FC",
    },
  },
  hideFilter: {
    display: "none",
  },
  filterIconContainer: {
    display: "flex",
    // justifyContent: "flex-start",
    placeContent: "center flex-start",
    alignItems: "center",

    "&>span": {
      marginRight: "8px",
      fontSize: "14px",
      fontWeight: 600,
      fontFamily: "Poppins",
      lineHeight: "32px",
      color: "var(--theme-primary)",
    },
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 57px)",

    "&>header": {
      flex: "unset",
      minHeight: "unset",
    },
  },
};

export const dataTableStyles = {
  table: {
    style: {
      borderStyle: "solid",
      borderWidth: "2px",
      borderColor: "#EFF1F6",
    },
  },
  head: {
    style: {
      minHeight: "37px",
    },
  },

  header: {
    style: {
      minHeight: "37px",
    },
  },

  headRow: {
    style: {
      backgroundColor: "#FBFBFC",
      minHeight: "37px",
      // borderTopStyle: "solid",
      // borderTopWidth: "1px",
      // borderTopColor: "#EFF1F6",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      fontWeight: "600",
      // whiteSpace: "nowrap !important",
      // overflow: "hidden !important",
      // textOverflow: "ellipsis !important",

      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "2px",
        borderRightColor: "#EFF1F6",
      },
    },
  },
  rows: {
    style: {
      minHeight: "37px !important", // override the row height
    },
    selectedHighlighStyle: {
      backgroundColor: "rgba(115,103,240,.05)",
      color: "#7367F0 !important",
      boxShadow: "0 0 1px 0 #7367F0 !important",

      "&:hover": {
        transform: "translateY(0px) !important",
      },
    },
  },

  cells: {
    style: {
      overflow: "hidden !important",
      whiteSpace: "nowrap !important",
      textOverflow: "ellipsis !important",

      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "2px",
        borderRightColor: "#EFF1F6",
      },
    },
  },
};
export const dataTableStylesWFsearch = {
  table: {
    style: {
      borderStyle: "solid",
      borderWidth: "2px",
      borderColor: "#EFF1F6",
    },
  },
  head: {
    style: {
      minHeight: "37px",
    },
  },
  header: {
    style: {
      minHeight: "37px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#FBFBFC",
      minHeight: "37px",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      fontWeight: "600",
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "2px",
        borderRightColor: "#EFF1F6",
      },
    },
  },
  rows: {
    style: {
      minHeight: "40px !important", // minimum height of 40px
      maxHeight: "80px !important", // maximum height of 80px
      height: "auto", // auto-adjust based on content
      display: "flex",
      alignItems: "center", // center row content vertically
      overflow: "hidden", // clip any overflow from the row
    },
    selectedHighlighStyle: {
      backgroundColor: "rgba(115,103,240,.05)",
      color: "#7367F0 !important",
      boxShadow: "0 0 1px 0 #7367F0 !important",
      "&:hover": {
        transform: "translateY(0px) !important",
      },
    },
  },
  cells: {
    style: {
      position: "relative", // create a containing block for the inner div
      padding: "0 8px", // horizontal padding
      height: "100%", // fill the row height
      overflow: "hidden", // clip any overflowing content
      boxSizing: "border-box", // ensure padding is contained inside cell boundaries

      // Target the cell-inner class
      "& .cell-inner": {
        position: "absolute",
        top: "50%", // position at the vertical middle
        left: 0,
        right: 0,
        padding: "0 8px",
        transform: "translateY(-50%)", // shift up by half its height
        overflow: "hidden",
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        whiteSpace: "normal",
      },

      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "2px",
        borderRightColor: "#EFF1F6",
      },
    },
  },
};
